import { z } from "zod";
function schemaModel(data, schema, throwError = true) {
  const result = schema.safeParse(data);
  if (!result.success) {
    console.error("Zod Schema Error");
    console.group();
    result.error.issues.forEach((issue) => {
      console.log(`Path: ${issue.path.join(", ")} 
Error: ${issue.message}`);
    });
    console.groupEnd();
  }
  if (throwError && !result.success) throw new Error("Zod validation failure");
  return result.success ? result.data : null;
}
const emailSchema = z.string().email().transform((a) => a.toLowerCase());
const timestampSchema = z.number().int().min(0);
const nanoidSchema = z.string().min(5);
function unixTimestamp(date = Date.now()) {
  return Math.floor(new Date(date).getTime() / 1e3);
}
var Environments = /* @__PURE__ */ ((Environments2) => {
  Environments2["Dev"] = "development";
  Environments2["Test"] = "test";
  Environments2["Prod"] = "production";
  Environments2["Staging"] = "staging";
  return Environments2;
})(Environments || {});
const deployEnvironmentsSchema = z.nativeEnum(Environments).optional().default("development" /* Dev */);
const regexSemverNumberedGroups = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
const semverSchema = z.string().regex(regexSemverNumberedGroups);
function arrayToMap(array) {
  return array.reduce((acc, item) => {
    acc[item.uid] = item;
    return acc;
  }, {});
}
const regexSlug = /^[a-z](?:[a-z0-9-]*[a-z0-9])?$/;
const slugSchema = z.string().min(1, "Slug is required").min(3, "Slug must be at least 3 characters").max(60, "Slug must be less than 60 characters").regex(regexSlug, {
  message: "Slug can have lowercase letters, digits, or hyphens. It must start with a lowercase letter and end with a letter or number."
});
const setPreprocess = (input) => input instanceof Set ? input : Array.isArray(input) ? new Set(input) : input;
const setTransform = (set) => Array.from(set);
const scalarSet = (zodSetType) => z.preprocess(setPreprocess, zodSetType).transform(setTransform);
const slugify = (v) => v.normalize("NFC").toLowerCase().trim().replace(/[^\p{L}\p{M}\p{N}\s-]/gu, "").replace(/[\s-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 255);
export {
  Environments,
  arrayToMap,
  deployEnvironmentsSchema,
  emailSchema,
  nanoidSchema,
  regexSemverNumberedGroups,
  regexSlug,
  scalarSet,
  schemaModel,
  semverSchema,
  slugSchema,
  slugify,
  timestampSchema,
  unixTimestamp
};
//# sourceMappingURL=index.js.map
